import * as Avatar from '@radix-ui/react-avatar';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { sessionQuery, useLogout } from '@/api/session';
import { LogOut } from '@/components/icons/glyphs/LogOut'; import { ShieldCheck } from '@/components/icons/glyphs/ShieldCheck';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const initials = (name: string, email: string) =>
  (name || email)
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');

export function UserMenu() {
  const { data } = useQuery(sessionQuery);
  const logout = useLogout();
  const navigate = useNavigate();
  if (!data) return null;
  const { user } = data;

  const onLogout = () =>
    logout.mutate(undefined, {
      onSettled: () => {
        toast.success('Sesión cerrada');
        void navigate({ to: '/login' });
      },
    });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="rounded-full transition-shadow hover:ring-2 hover:ring-border"
        aria-label={`Menú de usuario de ${user.name || user.email}`}
      >
        <Avatar.Root className="flex size-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground">
          <Avatar.Fallback>{initials(user.name, user.email)}</Avatar.Fallback>
        </Avatar.Root>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuLabel>
          <div className="text-sm font-medium text-foreground">{user.name || 'Usuario'}</div>
          <div className="truncate text-xs">{user.email}</div>
          {user.isPlatformAdmin ? <div className="mt-1 text-xs text-primary">Administrador de plataforma</div> : null}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => void navigate({ to: '/security' })}>
          <ShieldCheck className="size-4" aria-hidden />
          Seguridad
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onLogout}>
          <LogOut className="size-4" aria-hidden />
          Cerrar sesión
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
